import axios from 'axios';
import {
   PDFDownloadLink,
   PDFViewer,
   Document,
   Page,
   Image,
   Text,
   View,
   StyleSheet,
   Link,
   Font,
} from '@react-pdf/renderer';

export const renderHeader = (styles,settings) => (
   <View style={styles.header}>
     <Text>{settings.setting?.gmpcp_header_text || ''}</Text>
   </View>
 );
 export const renderFooter = (styles,settings) => (
   <View style={styles.footer}>
     <Text>{settings.setting?.gmpcp_footer_text || ''}</Text>
   </View>
 );

export const chunkArray = (array, pageBreak, columnsPerRow) => {
   const rowsPerPage = Math.ceil(pageBreak / columnsPerRow);
   const result = [];

   for (let i = 0; i < array.length; i += rowsPerPage * columnsPerRow) {
      let pageChunk = [];

      for (let j = i; j < i + rowsPerPage * columnsPerRow && j < array.length; j += columnsPerRow) {
         pageChunk.push(array.slice(j, j + columnsPerRow));
      }

      result.push(pageChunk);
   }

   return result;
};
export const chunkArrayList = (array, size) => {
      const chunkedArr = [];
      for (let i = 0; i < array.length; i += size) {
         chunkedArr.push(array.slice(i, i + size));
      }
      return chunkedArr;
   };
export const groupByCategory = (products) => {
 const categoryMap = {};
 products.forEach((product) => {
    if (product.producat_cat && product.producat_cat.length > 0) {
       product.producat_cat.forEach((category) => {
          if (!categoryMap[category]) categoryMap[category] = [];
          categoryMap[category].push(product);
       });
    } else {
       if (!categoryMap['Uncategorized']) categoryMap['Uncategorized'] = [];
       categoryMap['Uncategorized'].push(product);
    }
 });
 return categoryMap;
};

export const fetchProducts = async (rest_api_product, setProducts, setCurrentPage, setTotalPages, setError, setIsLoading) => {
   try {
      let productsApiUrl = `${rest_api_product}`;
      let currentPage = 1;
      let allProducts = [];
      let totalPages = 1;

      while (currentPage <= totalPages) {
         const separator = productsApiUrl.includes('?') ? '&' : '?';
         let response = await axios.get(`${productsApiUrl}${separator}page=${currentPage}`);

         allProducts = [...allProducts, ...response.data];
         totalPages = response.headers['x-wp-totalpages'];
         setCurrentPage(currentPage);
         setTotalPages(totalPages);
         currentPage++;
      }

      setProducts(allProducts);
   } catch (error) {
      console.error('Error fetching products:', error);
      setError('Error fetching products');
   } finally {
      setIsLoading(false);
   }
};
